import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Albania (1-48)
import albania1 from '../images/albania1.jpeg';
import albania2 from '../images/albania2.jpeg';
import albania3 from '../images/albania3.jpeg';
import albania4 from '../images/albania4.jpeg';
import albania5 from '../images/albania5.jpeg';
import albania6 from '../images/albania6.jpeg';
import albania7 from '../images/albania7.jpeg';
import albania8 from '../images/albania8.jpeg';
import albania9 from '../images/albania9.jpeg';
import albania10 from '../images/albania10.jpeg';
import albania11 from '../images/albania11.jpeg';
import albania12 from '../images/albania12.jpeg';
import albania13 from '../images/albania13.jpeg';
import albania14 from '../images/albania14.jpeg';
import albania15 from '../images/albania15.jpeg';
import albania16 from '../images/albania16.jpeg';
import albania17 from '../images/albania17.jpeg';
import albania18 from '../images/albania18.jpeg';
import albania19 from '../images/albania19.jpeg';
import albania20 from '../images/albania20.jpeg';
import albania21 from '../images/albania21.jpeg';
import albania22 from '../images/albania22.jpeg';
import albania23 from '../images/albania23.jpeg';
import albania24 from '../images/albania24.jpeg';
import albania25 from '../images/albania25.jpeg';
import albania26 from '../images/albania26.jpeg';
import albania27 from '../images/albania27.jpeg';
import albania28 from '../images/albania28.jpeg';
import albania29 from '../images/albania29.jpeg';
import albania30 from '../images/albania30.jpeg';
import albania31 from '../images/albania31.jpeg';
import albania32 from '../images/albania32.jpeg';
import albania33 from '../images/albania33.jpeg';
import albania34 from '../images/albania34.jpeg';
import albania35 from '../images/albania35.jpeg';
import albania36 from '../images/albania36.jpeg';
import albania37 from '../images/albania37.jpeg';
import albania38 from '../images/albania38.jpeg';
import albania39 from '../images/albania39.jpeg';
import albania40 from '../images/albania40.jpeg';
import albania41 from '../images/albania41.jpeg';
import albania42 from '../images/albania42.jpeg';
import albania43 from '../images/albania43.jpeg';
import albania44 from '../images/albania44.jpeg';
import albania45 from '../images/albania45.jpeg';
import albania46 from '../images/albania46.jpeg';
import albania47 from '../images/albania47.jpeg';
import albania48 from '../images/albania48.jpeg';

function Albania() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    albania1, albania2, albania3, albania4, albania5, albania6, albania7, albania8, albania9, albania10,
    albania11, albania12, albania13, albania14, albania15, albania16, albania17, albania18, albania19, albania20,
    albania21, albania22, albania23, albania24, albania25, albania26, albania27, albania28, albania29, albania30,
    albania31, albania32, albania33, albania34, albania35, albania36, albania37, albania38, albania39, albania40,
    albania41, albania42, albania43, albania44, albania45, albania46, albania47, albania48
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇦🇱 Albania 2022 🇦🇱</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Albania ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Albania;